import React, { useState } from 'react';
import { IoClose } from 'react-icons/io5';
import { FaChevronRight } from 'react-icons/fa';

const ColorGalleryTab = ({ colors }) => {
  const [selectedColor, setSelectedColor] = useState(null);

  if (!colors || colors.length === 0) {
    return (
      <div className="text-center py-16 bg-[#F4F1EA] rounded-2xl border border-dashed border-[#D9D9D9]">
        <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-[#F4F1EA] flex items-center justify-center">
          <svg className="w-8 h-8 text-[#79716B]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zm10 0a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zm10 0a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
          </svg>
        </div>
        <p className="text-[#79716B] font-medium">اطلاعات رنگ‌بندی برای این محصول موجود نیست</p>
        <p className="text-xs text-[#79716B]/60 mt-1">برای مشاهده رنگ‌ها با پشتیبانی تماس بگیرید</p>
      </div>
    );
  }

  return (
    <div className="space-y-8">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold text-[#292524]">گالری رنگ‌ها</h2>
          <p className="text-sm text-[#79716B] mt-1">{colors.length} رنگ موجود برای این محصول</p>
        </div>
        <span className="text-xs font-medium text-[#9EAD8C] bg-[#9EAD8C]/10 px-3 py-1 rounded-full">
          {colors.length} رنگ
        </span>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5">
        {colors.map((color) => (
          <div
            key={color.id}
            className="group cursor-pointer rounded-xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1 bg-white border border-[#D9D9D9]/50"
            onClick={() => setSelectedColor(color)}
          >
            <div
              className="w-full h-32 transition-transform duration-500 group-hover:scale-105"
              style={{ backgroundColor: color.code }}
            />
            <div className="bg-white px-4 py-3 text-center border-t border-[#D9D9D9]/50">
              <p className="text-sm font-semibold text-[#292524]">{color.name}</p>
              <p className="text-xs text-[#79716B] mt-0.5">{color.code}</p>
              <span className="inline-block mt-2 text-[10px] font-medium text-[#9EAD8C] opacity-0 group-hover:opacity-100 transition-opacity">
                مشاهده جزئیات
              </span>
            </div>
          </div>
        ))}
      </div>

      {/* Modal */}
      {selectedColor && (
        <div
          className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-50 p-4 animate-in fade-in duration-200"
          onClick={() => setSelectedColor(null)}
        >
          <div
            className="relative max-w-md w-full animate-in zoom-in-90 duration-200"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setSelectedColor(null)}
              className="absolute -top-14 left-0 text-white/80 hover:text-white transition-colors p-2 hover:bg-white/10 rounded-full"
            >
              <IoClose className="w-8 h-8" />
            </button>

            <div className="bg-white rounded-2xl overflow-hidden shadow-2xl">
              <div
                className="w-full h-64 transition-all"
                style={{ backgroundColor: selectedColor.code }}
              />
              <div className="px-6 py-5 text-center">
                <div className="flex items-center justify-center gap-3 mb-2">
                  <div
                    className="w-5 h-5 rounded-full border-2 border-[#D9D9D9]"
                    style={{ backgroundColor: selectedColor.code }}
                  />
                  <h3 className="text-xl font-bold text-[#292524]">{selectedColor.name}</h3>
                </div>
                <p className="text-sm text-[#79716B]">کد رنگ: {selectedColor.code}</p>
                <button
                  onClick={() => setSelectedColor(null)}
                  className="mt-4 px-6 py-2 bg-[#9EAD8C] text-white rounded-lg text-sm font-medium hover:bg-[#8A9A7B] transition-colors"
                >
                  بستن
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ColorGalleryTab;